import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { MutationFunction } from '@tanstack/react-query';
import { MosError } from 'src/utils/errors/MosError';

const setUserTenant: MutationFunction<boolean, string> = async (
  tenantId: string,
) => {
  if (isMockServices()) {
    return await mock(_mockData);
  }

  try {
    const authTokenHttp = await getCompatibleAuthTokenHttp();
    const response = await authTokenHttp<{ success: boolean }>(
      `/shared/users/myself/active-tenant`,
      {
        method: 'PUT',
        body: {
          tenantId: tenantId,
        },
      },
    );

    if (response.data) return response.data.success;
    throw new MosError({
      message: 'Failed to set user tenant',
      statusCode: response.status,
    });
  } catch (error) {
    if (error instanceof MosError) {
      throw error;
    }
    throw new MosError({
      message:
        error instanceof Error ? error.message : 'Failed to set user tenant',
      statusCode: 0,
    });
  }
};

export default setUserTenant;

const _mockData: boolean = true;
